import * as React from 'react'
import { Box, Fab, CircularProgress, Tooltip } from '@mui/material'
import { Edit, Star, Delete, AccountTree } from '@mui/icons-material'
import { green, amber, red, blue, teal } from '@mui/material/colors'
import { setCantonTenantPrimary } from '../../../services/cantonTenantService'

const RelationActions = ({ params, onEdit, onDelete, onRefresh, onReassign }) => {
  const [loading, setLoading] = React.useState(false)

  const handleSetPrimary = async () => {
    setLoading(true)
    const result = await setCantonTenantPrimary(params.row.id)
    if (result?.success && onRefresh) {
      onRefresh()
    }
    setLoading(false)
  }

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 0.5 }}>
      <Tooltip title="Editar">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: blue[500],
              '&:hover': { bgcolor: blue[700] },
            }}
            disabled={loading}
            onClick={() => onEdit(params.row)}>
            <Edit sx={{ fontSize: 18, color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title="Marcar como principal">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: params.row.isPrimary ? amber[700] : amber[500],
              '&:hover': { bgcolor: amber[700] },
            }}
            disabled={loading || params.row.isPrimary}
            onClick={handleSetPrimary}>
            <Star sx={{ fontSize: 18 }} />
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title="Reasignar árboles al tenant">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: teal[500],
              '&:hover': { bgcolor: teal[700] },
            }}
            disabled={loading}
            onClick={() => onReassign && onReassign(params.row)}>
            <AccountTree sx={{ fontSize: 18, color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title="Eliminar">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: red[500],
              '&:hover': { bgcolor: red[700] },
            }}
            disabled={loading}
            onClick={() => onDelete(params.row)}>
            <Delete sx={{ fontSize: 18, color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      {loading && (
        <CircularProgress
          size={40}
          sx={{ color: green[500], position: 'absolute', top: -4, left: -4, zIndex: 1 }}
        />
      )}
    </Box>
  )
}

export default RelationActions
